export default function EikaMenuComponent(rootElement: HTMLElement) {
    if (typeof rootElement === 'undefined' || rootElement === null) {
        return;
    }
    const header: HTMLElement | null = rootElement;
    const menuButton: HTMLButtonElement | null = document.querySelector('#toggleMenuButton');
    const menuContainer: HTMLElement | null = document.querySelector('.menu');
    const menuInner: HTMLElement | null = menuContainer?.querySelector('.menu__container') ?? null;
    const toggleLoginBtn: HTMLElement | null = menuContainer?.querySelector('#login-menu-toggle') ?? null;
    const primaryMenuList: HTMLElement | null = menuContainer?.querySelector('#primary-navigation-list') ?? null;
    const menuParentBtn: NodeListOf<HTMLButtonElement> | undefined = menuContainer?.querySelectorAll(
        '.menu__item-header .menu__item--container',
    );
    const menuLoginSelection: HTMLElement | null = menuContainer?.querySelector('#login-selection') ?? null;
    const menuOpenClass = 'menu--open';
    const tabbableElements = Array.from(
        menuContainer?.querySelectorAll('button,input,select,textarea,[href],[tabindex]:not([tabindex="-1"])') ?? [],
    );
    const overlayDiv: HTMLElement | null = document.querySelector('#nav-overlay');
    if (overlayDiv && menuContainer) {
        menuContainer.style.display = '';
        overlayDiv.style.display = '';
    }
    const menuIsVisible = () => {
        return document.body.classList.contains(menuOpenClass);
    };

    const toggleLoginList = (): void => {
        if (!toggleLoginBtn || !primaryMenuList) return;

        const isExpanded = toggleLoginBtn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
            document.body.classList.remove('login-active');
            menuLoginSelection?.setAttribute('inert', 'true');
        } else {
            document.body.classList.add('login-active');
            menuLoginSelection?.removeAttribute('inert');
            menuLoginSelection?.querySelector('a')?.focus();
        }

        if (toggleLoginBtn.hasAttribute('aria-controls')) {
            const loginSelectionId = toggleLoginBtn.getAttribute('aria-controls') ?? '';
            const loginSelection = document.getElementById(loginSelectionId);
            if (!loginSelection) return;

            toggleLoginBtn.setAttribute('aria-expanded', String(!isExpanded));
            toggleLoginBtn.querySelector('.btn-lbl')!.textContent = isExpanded
                ? toggleLoginBtn.getAttribute('data-open') || 'Logg inn'
                : toggleLoginBtn.getAttribute('data-close') || 'Close';
        }
    };

    const forceCloseLoginList = (): void => {
        if (!toggleLoginBtn) return;

        document.body.classList.remove('login-active');
        toggleLoginBtn.setAttribute('aria-expanded', 'false');
        toggleLoginBtn.querySelector('.btn-lbl')!.textContent = toggleLoginBtn.getAttribute('data-open') || 'Logg inn';
    };

    const closeAllOpenMenus = (): void => {
        const openSubMenus = menuContainer?.querySelectorAll('.menu__submenu--active');
        if (openSubMenus && openSubMenus.length > 0) {
            openSubMenus.forEach((subel) => {
                subel.classList.remove('menu__submenu--active');
                subel.querySelector('button')?.setAttribute('aria-expanded', 'false');
            });
        }
    };

    if (menuButton !== null && menuContainer !== null) {
        const closeOpenMenus = (currentTarget: HTMLLIElement) => {
            const openSubMenus = menuContainer.querySelectorAll('.menu__submenu--active');
            if (openSubMenus.length > 0) {
                openSubMenus.forEach((subel) => {
                    if (typeof currentTarget === 'undefined' || subel !== currentTarget) {
                        subel.classList.remove('menu__submenu--active');
                        subel.querySelector('button')?.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        };

        const toggleSubMenus = (e: Event): void => {
            const expandEl = (e.target as HTMLElement).closest('.menu__item-header') as HTMLLIElement;
            const btn = e.target as HTMLElement;
            const activeListItemClass = 'menu__submenu--active';
            if (expandEl !== null) {
                closeOpenMenus(expandEl);
                const isActive = expandEl.classList.toggle(activeListItemClass);
                btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
            e.preventDefault();
        };

        const toggleMenu = (): void => {
            const btnLabel = menuButton.querySelector('.menu-label') as HTMLElement;
            const elementsToBlock = ['#maincontent', '.ebanking-footer', '#noticebar-wrapper-inerter'];
            const blockElements = document.querySelectorAll(elementsToBlock.join(', '));

            if (btnLabel !== null) {
                if (!menuIsVisible()) {
                    document.body.classList.add(menuOpenClass);
                    menuButton.setAttribute('aria-expanded', 'true');
                    const ariaLabelClose = `${btnLabel.getAttribute('data-dictionary-close')!} ${btnLabel.getAttribute(
                        'data-dictionary-open',
                    )!}` as string;
                    menuButton.setAttribute('aria-label', ariaLabelClose);
                    btnLabel.innerText = btnLabel.getAttribute('data-dictionary-close')!;
                    menuContainer.removeAttribute('inert');
                    forceCloseLoginList();

                    if (blockElements.length) {
                        blockElements.forEach((el) => {
                            (el as HTMLElement).setAttribute('inert', 'true');
                        });
                    }
                } else {
                    document.body.classList.remove(menuOpenClass);
                    menuButton.setAttribute('aria-expanded', 'false');
                    const ariaLabelOpen = btnLabel.getAttribute('data-dictionary-open')! as string;
                    menuButton.setAttribute('aria-label', ariaLabelOpen);
                    btnLabel.innerText = ariaLabelOpen;
                    menuContainer.setAttribute('inert', 'true');

                    if (blockElements.length) {
                        blockElements.forEach((el) => {
                            (el as HTMLElement).removeAttribute('inert');
                        });
                    }
                }
            }
        };

        menuButton.addEventListener('click', (e: Event) => {
            toggleMenu();
            e.preventDefault();
        });
        document.addEventListener('click', (e) => {
            const clickedElm = e.target as Node | null;
            if (!clickedElm || !menuButton || !menuInner || !header) return;

            const login: HTMLElement | null = header.querySelector('.login-dropdown');

            if (menuInner.contains(clickedElm)) return;
            if (menuButton.contains(clickedElm)) return;
            if (login && login.contains(clickedElm)) {
                if (menuIsVisible()) toggleMenu();
                return;
            }
            if (header.contains(clickedElm)) {
                if ((clickedElm as HTMLElement).closest('a')) {
                    return;
                }
                if (menuIsVisible()) toggleMenu();
                return;
            }
            if (menuIsVisible()) {
                toggleMenu();
            }
        });

        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (!menuIsVisible()) {
                return;
            }

            if (e.key === 'Tab' && !e.shiftKey) {
                const inFocus = document.activeElement;
                const lastMenuItem = tabbableElements[tabbableElements.length - 1];

                if (lastMenuItem === inFocus) {
                    menuButton.focus();
                    e.preventDefault();
                }
            }
            if (e.key === 'Escape' || e.keyCode === 27) {
                toggleMenu();
                e.preventDefault();
                closeAllOpenMenus();
                menuButton.focus();
            }
        });

        menuParentBtn?.forEach((btn: HTMLButtonElement) => {
            btn.addEventListener('click', toggleSubMenus);
        });

        if (toggleLoginBtn && primaryMenuList) {
            toggleLoginBtn.addEventListener('click', toggleLoginList);
        }
    }
}
